"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "IGetInboxMessagesParams", {
  enumerable: true,
  get: function get() {
    return messages.IGetInboxMessagesParams;
  }
});
exports["default"] = void 0;

var _client = require("../client");

var _count = require("./count");

var message = _interopRequireWildcard(require("./message"));

var messageLists = _interopRequireWildcard(require("./message-lists"));

var messages = _interopRequireWildcard(require("./messages"));

var _markAllRead = require("./mark-all-read");

var _trackEvent = require("./track-event");

var _default = function _default(params) {
  var client = (0, _client.createCourierClient)(params, {
    apiUrl: "https://inbox.courier.com/q"
  });
  return {
    addTag: (0, _trackEvent.trackEvent)(client)("addTag"),
    removeTag: (0, _trackEvent.trackEvent)(client)("removeTag"),
    getInboxCount: (0, _count.getInboxCount)(client),
    getMessage: message.getInboxMessage(client),
    getMessageLists: messageLists.getMessageLists(client),
    getMessages: messages.getInboxMessages(client),
    markAllRead: (0, _markAllRead.markAllRead)(client),
    markArchive: (0, _trackEvent.trackEvent)(client)("archive"),
    markOpened: (0, _trackEvent.trackEvent)(client)("opened"),
    markRead: (0, _trackEvent.trackEvent)(client)("read"),
    markUnread: (0, _trackEvent.trackEvent)(client)("unread"),
    trackClick: (0, _trackEvent.trackEvent)(client)("clicked"),
    unpinMessage: (0, _trackEvent.trackEvent)(client)("unpin")
  };
};

exports["default"] = _default;